export default {
  types : [
  "blue",
  "purple",
  "yellow",
  "white"
  ],
  names : [
  "Adapedonta",
  "Anomalodes",
  "Arcida",
  "Cardiida",
  "Carditida",
  "Galeommatida",
  "Gastrocha",
  "Hippuritida",
  "Praecardiida",
  "Pteriida",
  "Solemyida",
  "Sphaeriida",
  "Trigoniida",
  "Tuarangiida",
  "Unionida",
  "Venerida",
  "Abraliopsis",
  "Adelieledone",
  "Afrololigo",
  "Alloteuthis",
  "Amphitretus",
  "Ancistroche",
  "Ancistrot",
  "Angaroceras",
  "Architeuthis",
  "Argonauta",
  "Bathypurpurat",
  "Batoteuthis",
  "Belosaepia",
  "Bentheledone",
  "Berryteuthis",
  "Bigfin squid",
  "Cirrothauma",
  "Cistopus",
  "Cochlioceras",
  "Cryptocyclo",
  "Cryptoteuthis",
  "Curtoceras",
  "Cycloteuthis",
  "Discoteuthis",
  "Donacoceras",
  "Doryteuthis",
  "Eledone",
  "Endorioceras",
  "Engorthoceras",
  "Enoploteuthis",
  "Eosomichel",
  "Euaxoctopus",
  "Galiteuthis",
  "Garryoceras",
  "Geisonocerin",
  "Graneledone",
  "Grimaldite",
  "Grimpella",
  "Illex",
  "Inioteuthis",
  "Iridoteuthis",
  "Litoceras",
  "Loligo",
  "Loliolus",
  "Magnoteuthis",
  "Mastigopsis",
  "Mastigos",
  "Megaleledone",
  "Mericoceras",
  "Metasepia",
  "Microeledon",
  "Nectoteuth",
  "Nematolampa",
  "Neorossia",
  "Neosichua",
  "Onychot",
  "Onykia",
  "Opistho",
  "Paroctopus",
  "Peismoceras",
  "Pholido",
  "Pinnoctopus",
  "Plesioteu",
  "Protoba",
  "Psychrot",
  "Pteroctopus",
  "Scaeurgus",
  "Semiannul",
  "Semirossia",
  "Sepia",
  "Sepiadarium",
  "Sepioloidea",
  "Shantung",
  "Shimanskya",
  "Spirula",
  "Taonius",
  "Teretopus",
  "Tetrachel",
  "Teudopsis",
  "Vosseledon",
  "Vultopus",
  "Walviste",
  "Watasenia",
  "Xipholeptos"
  ],
  words : [
    "lorem",
    "ipsum",
    "dolor",
    "sit",
    "amet",
    "consectetur",
    "adipiscing",
    "elit",
    "estne",
    "quaeso",
    "inquam",
    "sitienti",
    "in",
    "bibendo",
    "voluptas",
    "quam",
    "ob",
    "rem",
    "tandem",
    "inquit",
    "non",
    "satisfacit",
    "sit",
    "enim",
    "idem",
    "caecus",
    "debilis",
    "minime",
    "vero",
    "istorum",
    "quidem",
    "inquit",
    "maximus",
    "dolor",
    "inquit",
    "brevis",
    "est",
    "quid",
    "me",
    "istud",
    "rogas",
    "cum",
    "praesertim",
    "illa",
    "perdiscere",
    "ludus",
    "esset",
    "quae",
    "sequuntur",
    "igitur",
    "sed",
    "residamus",
    "inquit",
    "si",
    "placet",
    "age",
    "inquies",
    "ista",
    "parva",
    "sunt",
    "istam",
    "voluptatem",
    "inquit",
    "epicurus",
    "ignorat",
    "odium",
    "autem",
    "et",
    "invidiam",
    "facile",
    "vitabis",
    "quid",
    "me",
    "istud",
    "rogas",
    "sed",
    "ille",
    "ut",
    "dixi",
    "vitiose",
    "ego",
    "vero",
    "isti",
    "inquam",
    "permitto",
    "at",
    "ille",
    "pellit",
    "qui",
    "permulcet",
    "sensum",
    "voluptate",
    "nos",
    "vero",
    "inquit",
    "ille;",
    "duo",
    "enim",
    "genera",
    "quae",
    "erant",
    "fecit",
    "tria",
    "philosophi",
    "autem",
    "in",
    "suis",
    "lectulis",
    "plerumque",
    "moriuntur",
    "respondent",
    "extrema",
    "primis",
    "media",
    "utrisque",
    "omnia",
    "omnibus",
    "eam",
    "tum",
    "adesse",
    "cum",
    "dolor",
    "omnis",
    "absit;",
    "haec",
    "dicuntur",
    "inconstantissime",
    "erat",
    "enim",
    "res",
    "aperta",
    "egone",
    "non",
    "intellego",
    "quid",
    "sit",
    "don",
    "graece",
    "latine",
    "voluptas",
    "itaque",
    "ad",
    "tempus",
    "ad",
    "pisonem",
    "omnes",
    "sed",
    "potestne",
    "rerum",
    "maior",
    "esse",
    "dissensio",
    "mihi",
    "inquam",
    "qui",
    "te",
    "id",
    "ipsum",
    "rogavi",
    "quis",
    "aristidem",
    "non",
    "mortuum",
    "diligit",
    "est",
    "enim",
    "effectrix",
    "multarum",
    "et",
    "magnarum",
    "voluptatum",
    "contineo",
    "me",
    "ab",
    "exemplis",
    "istam",
    "voluptatem",
    "inquit",
    "epicurus",
    "ignorat",
    "duo",
    "reges",
    "constructio",
    "interrete",
    "an",
    "nisi",
    "populari",
    "fama",
    "cur",
    "nisi",
    "quod",
    "turpis",
    "oratio",
    "est",
    "negat",
    "esse",
    "eam",
    "inquit",
    "propter",
    "se",
    "expetendam",
    "de",
    "hominibus",
    "dici",
    "non",
    "necesse",
    "est",
    "refert",
    "tamen",
    "quo",
    "modo",
    "a",
    "mene",
    "tu",
    "conferam",
    "tecum",
    "quam",
    "cuique",
    "verso",
    "rem",
    "subicias;",
    "occultum",
    "facinus",
    "esse",
    "potuerit",
    "gaudebit;",
    "cur",
    "post",
    "tarentum",
    "ad",
    "archytam",
    "verum",
    "hoc",
    "idem",
    "saepe",
    "faciamus",
    "itaque",
    "ab",
    "his",
    "ordiamur",
    "a",
    "mene",
    "tu",
    "summum",
    "ením",
    "bonum",
    "exposuit",
    "vacuitatem",
    "doloris;",
    "sed",
    "residamus",
    "inquit",
    "si",
    "placet",
    "immo",
    "videri",
    "fortasse",
    "laboro",
    "autem",
    "non",
    "sine",
    "causa;",
    "sed",
    "virtutem",
    "ipsam",
    "inchoavit",
    "nihil",
    "amplius"
  ],
  images : [
    'https://picsum.photos/id/117/160/120',
    'https://picsum.photos/id/118/160/120',
    'https://picsum.photos/id/119/160/120',
    'https://picsum.photos/id/12/160/120',
    'https://picsum.photos/id/120/160/120',
    'https://picsum.photos/id/121/160/120',
    'https://picsum.photos/id/122/160/120',
    'https://picsum.photos/id/123/160/120',
    'https://picsum.photos/id/124/160/120',
    'https://picsum.photos/id/125/160/120',
    'https://picsum.photos/id/126/160/120',
    'https://picsum.photos/id/127/160/120',
    'https://picsum.photos/id/128/160/120',
    'https://picsum.photos/id/129/160/120',
    'https://picsum.photos/id/13/160/120',
    'https://picsum.photos/id/130/160/120',
    'https://picsum.photos/id/131/160/120',
    'https://picsum.photos/id/132/160/120',
    'https://picsum.photos/id/133/160/120',
    'https://picsum.photos/id/134/160/120',
    'https://picsum.photos/id/135/160/120',
    'https://picsum.photos/id/136/160/120',
    'https://picsum.photos/id/137/160/120',
    'https://picsum.photos/id/139/160/120',
    'https://picsum.photos/id/14/160/120',
    'https://picsum.photos/id/140/160/120',
    'https://picsum.photos/id/141/160/120',
    'https://picsum.photos/id/142/160/120',
    'https://picsum.photos/id/143/160/120',
    'https://picsum.photos/id/144/160/120',
    'https://picsum.photos/id/145/160/120',
    'https://picsum.photos/id/146/160/120',
    'https://picsum.photos/id/147/160/120',
    'https://picsum.photos/id/149/160/120',
    'https://picsum.photos/id/15/160/120',
    'https://picsum.photos/id/151/160/120',
    'https://picsum.photos/id/152/160/120',
    'https://picsum.photos/id/153/160/120',
    'https://picsum.photos/id/154/160/120',
    'https://picsum.photos/id/155/160/120',
    'https://picsum.photos/id/156/160/120',
    'https://picsum.photos/id/157/160/120',
    'https://picsum.photos/id/158/160/120',
    'https://picsum.photos/id/159/160/120',
    'https://picsum.photos/id/16/160/120',
    'https://picsum.photos/id/160/160/120',
    'https://picsum.photos/id/161/160/120',
    'https://picsum.photos/id/162/160/120',
    'https://picsum.photos/id/163/160/120',
    'https://picsum.photos/id/164/160/120',
    'https://picsum.photos/id/165/160/120',
    'https://picsum.photos/id/166/160/120',
    'https://picsum.photos/id/167/160/120',
    'https://picsum.photos/id/168/160/120',
    'https://picsum.photos/id/169/160/120',
    'https://picsum.photos/id/17/160/120',
    'https://picsum.photos/id/170/160/120',
    'https://picsum.photos/id/171/160/120',
    'https://picsum.photos/id/172/160/120',
    'https://picsum.photos/id/173/160/120',
    'https://picsum.photos/id/174/160/120',
    'https://picsum.photos/id/175/160/120',
    'https://picsum.photos/id/176/160/120',
    'https://picsum.photos/id/177/160/120',
    'https://picsum.photos/id/178/160/120',
    'https://picsum.photos/id/179/160/120',
    'https://picsum.photos/id/18/160/120',
    'https://picsum.photos/id/180/160/120',
    'https://picsum.photos/id/181/160/120',
    'https://picsum.photos/id/182/160/120',
    'https://picsum.photos/id/183/160/120',
    'https://picsum.photos/id/184/160/120',
    'https://picsum.photos/id/185/160/120',
    'https://picsum.photos/id/186/160/120',
    'https://picsum.photos/id/187/160/120',
    'https://picsum.photos/id/188/160/120',
    'https://picsum.photos/id/189/160/120',
    'https://picsum.photos/id/19/160/120',
    'https://picsum.photos/id/190/160/120',
    'https://picsum.photos/id/191/160/120',
    'https://picsum.photos/id/192/160/120',
    'https://picsum.photos/id/193/160/120',
    'https://picsum.photos/id/194/160/120',
    'https://picsum.photos/id/195/160/120',
    'https://picsum.photos/id/196/160/120',
    'https://picsum.photos/id/197/160/120',
    'https://picsum.photos/id/198/160/120',
    'https://picsum.photos/id/199/160/120',
    'https://picsum.photos/id/2/160/120',
    'https://picsum.photos/id/20/160/120',
    'https://picsum.photos/id/200/160/120',
    'https://picsum.photos/id/201/160/120',
    'https://picsum.photos/id/202/160/120',
    'https://picsum.photos/id/203/160/120',
    'https://picsum.photos/id/204/160/120',
    'https://picsum.photos/id/206/160/120',
    'https://picsum.photos/id/208/160/120',
    'https://picsum.photos/id/209/160/120',
    'https://picsum.photos/id/21/160/120',
    'https://picsum.photos/id/210/160/120'
  ]
}